import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { UserDataService } from '../../services/user-data/user-data.service';
import { EnvService } from '../../services/env/env.service';

@Component({
    standalone: false,
    selector: 'octo-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
    userSummary$ = new Subscription();
    routeChange$ = new Subscription();
    userSummary: any;
    currentURL = 'hbhb';
    showLoginFooter = false;
    version: string;
    currentYear: string;

    constructor(
        private userDataService: UserDataService,
        private router: Router,
        private cdref: ChangeDetectorRef,
        private envService: EnvService
    ) {
        this.version = this.envService.version;
        this.currentYear = new Date().getFullYear().toString();
    }

    ngOnInit(): void {
        this.userSummary$ = this.userDataService
            .getUserSummary()
            .subscribe((data: any) => {
                this.userSummary = data;
            });
        console.info(`------- Version ------- \n ${this.version}`);
    }

    ngOnDestroy(): void {
        this.userSummary$.unsubscribe();
        this.routeChange$.unsubscribe();
    }
}
